module.exports = __webpack_public_path__ + "static/burn-studio-3b802647ad999502f28cbac4f3e58bba.jpg";